class ScaleBarMark {
	static seed(bar, time) {
		let i = new ScaleBarMark(bar);
		i.time = Math.floor(time / bar._scale.minor) * bar._scale.minor;
		return i;
	}

	static before(bar, marker) {
		let i = new ScaleBarMark(bar);
		i.time = marker.time - bar._scale.minor;
		return i;
	}

	static after(bar, marker) {
		let i = new ScaleBarMark(bar);
		i.time = marker.time + bar._scale.minor;
		return i;
	}

	constructor(bar) {
		this._scale = bar._scale;
		this._time;
		this._mark = UI.div('scaleMarker');
		this._text = UI.span('scaleMarkerLabel');
		bar._markBar.appendChild(this._mark);
		bar._markBar.appendChild(this._text);

	}

	dispose() {
		this._mark.remove();
		this._text.remove();
	}

	get text() {return this._text;}
	get line() {return this._line;}

	get start() {return this._time - this._scale.minor;}
	get end() {return this._time + this._scale.minor;}
	get time() {return this._time;}
	
	set time(v) {
		this._time = v;

		this._major = v % this._scale.major == 0;
		if (this._major) {
			let time = new Date(v);
			let hrs = time.getUTCHours();
			let mins = time.getUTCMinutes();
			if (hrs === 0 && mins === 0) this._text.innerHTML = '';
			else this._text.innerHTML = MinsPast(hrs, mins);
			this._text.style.display = 'block';
		}
		else {
			this._text.style.display = 'none';
		}
	}

	findMinor() {
		this._time = Math.floor(this._time / this._scale.minor) * this._scale.minor;
	}
	
	move() {
		let left = this._scale._timeline.timeToOffset(this._time);
		this._mark.style.left = left + 'px';
		this._text.style.left = left + 'px';
	}
}
